// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a873b0d7","703":"e0ad3a79","787":"b1de939b"}[chunkId] + ".chunk.js";
};